import { render, staticRenderFns } from "./HeaderMessage.vue?vue&type=template&id=0039b734&"
import script from "./HeaderMessage.vue?vue&type=script&lang=ts&"
export * from "./HeaderMessage.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderMessage.vue?vue&type=style&index=0&id=0039b734&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports